import Vue from "vue";
import moment from "moment";
import axios from "axios";
import * as files from "../../../../fileUtils";
import { v4 as uuidv4 } from "uuid";
import { date } from "devexpress-dashboard/model/index.metadata";

export default {
  name: "AttachmentsTable",

  props: {
    attachments: {
      type: Array,
      required: true,
    },
    attachmentTypes: {
      type: Array,
      required: true,
    },
    appKey: {
      type: Number,
      required: true,
    },
    applicationId: {
      type: String,
      required: true,
    },
    parent: {
      type: Object,
      required: true,
    },
    readOnly: {
      type: Boolean,
      required: true,
    },
    addRowEnable: {
      type: Boolean,
      default: false,
    },
    isMandatrory: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      appId: -1,
      editingAttachment: null,
      bConfirmDialog: false,
      deleteConfirmMessage: "",
      message: "",
      filename: "",
      name: "",
      comment: "",
      type: "",
      typesList: [],
      available: "",
      upMainCustTable: "",
      upAddCustTable: "",
      upPropCustTable: "",
      iCntrl: null,
      fileNameList: [],
      formData: null,
      isEditedIndex: -1,
      selectedFileList: [],
      selectedAttachList: "",
    };
  },
  created() {
    this.formData = null;
    this.isEditedIndex = -1; //No edit open on startup
  },
  methods: {
    addRow() {
      //create new attachment object and add it to array/gui
      this.attachments.push(this.newAttachment(false));
      this.isEditedIndex = this.attachments.length - 1;
    },
    editRow(item, index) {
      //error traps
      if (
        this.attachments.isSystem ||
        this.attachments == null ||
        this.attachments.length == 0
      )
        return;

      if (this.isEditedIndex >= 0) {
        this.$alertMsg(this.$t("manageAttachments.RowEditedError"), 4);
        return;
      }
      this.saveEditToggle(index);
    },
    saveEditToggle(index) {
      //save and edit table row

      //add edit tag to attachment object
      this.attachments[index].editDisabled =
        !this.attachments[index].editDisabled;

      if (!this.attachments[index].editDisabled) {
        //save index being edited
        this.isEditedIndex = index;
        this.parent.isEdited = true;
      } else {
        this.isEditedIndex = -1;
        this.parent.isEdited = false;
      }

      this.$forceUpdate();
    },
    saveFiles(event) {
      //save user file selection locally for later use
      //error trap
      if (event.target.files.length === 0 || this.applicationId < 0) return;

      this.selectedFileList = event.target.files;
      //console.log("sel file lst", this.attachments[this.isEditedIndex])
      this.attachments[this.isEditedIndex].available = true;
      this.attachments[this.isEditedIndex].fileName =
        this.selectedFileList[0].name;
    },
    saveRow(item, index) {
      if (index != null && !this.attachments[index].available) {
        this.$alertMsg(this.$t("common.NoAttachments"), 4);
        return;
      }

      //user saved row - post files
      //error trap
      if (this.applicationId < 0) return;

      //create new form to send to back end
      this.formData = new FormData();
      this.formData.append("AppId", this.applicationId);
      var curRow = this.attachments[index];
      //-----------------------------------Warning----------------------------------------------
      //----------------------------------------------------------------------------------------
      //----------------------------------------------------------------------------------------
      //some multi file support is coded BUT not everything is implemented
      //FUTURE work if asked to create new rows for each of the files selected
      //Save all the attachment IDs from back end
      //As is only work with one attachment
      //We can send multiple files to back and they are saved - at the time of writing
      //----------------------------------------------------------------------------------------
      //----------------------------------------------------------------------------------------
      //----------------------------------------------------------------------------------------
      var i = 0;
      do {
        if (this.selectedFileList[i] != null) {
          this.formData.append("uploadFiles", this.selectedFileList[i]);
          this.formData.append(
            "attachmentInfos[" + i + "].FileName",
            this.selectedFileList[i].name
          );
        }
        this.formData.append(
          "attachmentInfos[" + i + "].AttachmentId",
          curRow.attachmentId > -1 ? curRow.attachmentId : "-1"
        );
        this.formData.append(
          "attachmentInfos[" + i + "].ActivityAppKey",
          this.appKey
        );
        this.formData.append(
          "attachmentInfos[" + i + "].ApplicationId",
          this.applicationId
        );
        //this.formData.append("attachmentInfos[" + i + "].AttachmentType", curRow.attachmentType)
        this.formData.append("attachmentInfos[" + i + "].Available", true);
        this.formData.append("attachmentInfos[" + i + "].Name", curRow.name);
        this.formData.append("attachmentInfos[" + i + "].PortalAccess", true);
        this.formData.append(
          "attachmentInfos[" + i + "].Remarks",
          curRow.remarks == null || curRow.remarks == "null"
            ? ""
            : curRow.remarks
        );
        this.formData.append(
          "attachmentInfos[" + i + "].UpdateCustomerAdd",
          curRow.updateCustomerAdd
        );
        this.formData.append(
          "attachmentInfos[" + i + "].UpdateCustomerMain",
          curRow.updateCustomerMain
        );
        this.formData.append(
          "attachmentInfos[" + i + "].UpdateProperty",
          curRow.updateProperty
        );
        i++;
      } while (i < this.selectedFileList.length);

      axios
        .post("/ActivityAttachment/SaveAttachments", this.formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          if (response.status == 200) {
            //console.log("resp", response);
            this.$alertMsg(this.$t("messages.AttachmentSavedSuccess"), 2);
            //save attachmentId to local object
            this.attachments[index].attachmentId =
              response.data.attachmentIds[0];
            this.saveEditToggle(index);

            if (this.isMandatrory) {
              //mandatory attachments list check

              let hasCompletedAttachments = true;
              this.attachments.forEach((a) => {
                if (
                  a.isSystem &&
                  a.mandatory &&
                  (!a.available || a.fileName == "" || a.fileName == null)
                ) {
                  hasCompletedAttachments = false; //no attachment make false
                }
              });

              //enable/disable next button
              if (
                hasCompletedAttachments &&
                this.parent.parent.manageAttachmentsEnableNextOnUploadCompletion
              )
                this.parent.parent.manageAttachmentsEnableNext = true;
              else this.parent.parent.manageAttachmentsEnableNext = false;
            }
          } else this.$alertMsg(this.$t("messages.AttachmentSavedError"));
        })
        .catch((e) => {
          console.log(e);
          this.$alertMsg(this.$t("messages.AttachmentSavedError") + e);
        });
    },
    newAttachment(editDis) {
      //create new attachment object
      return {
        attachmentId: -1,
        activityAppKey: this.appKey,
        applicationId: this.applicationId,
        updateProperty: false,
        updateCustomerAdd: false,
        updateCustomerMain: false,
        available: false,
        remarks: "",
        name: "",
        fileName: "",
        attachmentType:
          this.attachmentTypes.length > 0
            ? this.attachmentTypes.filter((a) => a.selected == true)[0].value
            : "",
        editDisabled: editDis == false ? false : true,
        uuid: uuidv4(),
      };
    },
    addAttachment() {
      //add files selected by user
      var iCntrl1 = document.getElementById("upload-manage-attachments"); //upload is the id on vue file
      iCntrl1.click();
    },
    removeConfirm(item, index) {
      //pop up dialog to confirm delete - save delete object
      this.deleteConfirmMessage =
        this.$t("attachments.DeleteAttachment") +
        (item.fileName == null || item.fileName == ""
          ? " ?"
          : " [" + item.fileName + "] ?");
      this.editingAttachment = item;
      this.editingAttachment["isDeletedIndex"] = index;
      this.bConfirmDialog = true;
    },
    removeAttachment() {
      //remove attachment locally and send back end request
      //error trap
      if (!this.editingAttachment) {
        this.$alertMsg(this.$t("messages.AttachmentDeletedError"), 4);
        return;
      }

      //local delete if attachment not saved to back end
      if (this.editingAttachment.attachmentId < 0) {
        this.$alertMsg(this.$t("messages.AttachmentDeletedSuccess"), 2);
        this.saveEditToggle(this.isEditedIndex);
        this.attachments.splice(this.editingAttachment.isDeletedIndex, 1);
        return;
      }

      var formData = new FormData();
      formData.append("appId", this.applicationId);
      formData.append("deleteFiles", this.editingAttachment.attachmentId);
      var loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });
      axios
        .post("/ActivityAttachment/SaveAttachments", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((resp) => {
          //console.log("resp", resp);
          if (resp.status == 200) {
            this.$alertMsg(this.$t("messages.AttachmentDeletedSuccess"), 2);
            if (!this.editingAttachment.editDisabled)
              this.saveEditToggle(this.editingAttachment.isDeletedIndex);
            this.attachments = this.attachments.filter(
              (p) => p.uuid !== this.editingAttachment.uuid
            );
          } else this.$alertMsg(resp.data.data.text);
        })
        .catch((e) => {
          this.$alertMsg(this.$t("messages.AttachmentDeletedError") + e);
          console.log(e);
        })
        .finally(loader.hide());
    },
    download(item) {
      //download file from back end
      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });
      axios
        .get("/ActivityAttachment/Download?attachmentId=" + item.attachmentId, {
          responseType: "blob",
        })
        .then(files.getFile)
        .then((link) => {
          link.click();
        })
        .catch((err) => {
          console.log("download error: " + err);
          this.$alertMsg(this.$t("messages.FileDownloadError"));
        })
        .finally(loader.hide());
    },
    setSelectedAttachType() {},
  },
};
